import { Text } from '@chakra-ui/react'
import { hotelsApi } from '~/apis/hotelsApi'
import { systemSettingsApi } from '~/apis/systemSettingsApi'

import { HotelsDashboardPage } from '@mangovoice/hotels-ui'
import { LoadingState } from '@mangovoice/mango-ui'
import { usePbxTimeZone } from '@mangovoice/system-settings-ui'

import { HotelsAccessGate } from './HotelsAccessGate'
import { hotelsToast } from './hotelsToast'
import { useHotelsPageContext } from './useHotelsPageContext'

export const HotelsDashboardRoutePage = () => {
  const { t, locale, permissions, pbxId, pbxUuid } = useHotelsPageContext()
  const { pbxTimeZone, isLoading, isError } = usePbxTimeZone(
    systemSettingsApi,
    pbxId,
  )

  if (!pbxId || !pbxUuid) {
    return null
  }

  return (
    <HotelsAccessGate requiredAccess="dashboard">
      {isLoading ? (
        <LoadingState
          title=""
          size="lg"
          ariaLabel={t('hotels.common.loading', 'Loading')}
        />
      ) : isError || !pbxTimeZone ? (
        <Text fontSize="sm" color="fg.error" py={6}>
          {t(
            'hotels.errors.loadTimezone',
            'Could not load PBX timezone. Check system settings for this PBX.',
          )}
        </Text>
      ) : (
        <HotelsDashboardPage
          api={hotelsApi}
          pbxId={pbxId}
          pbxUuid={pbxUuid}
          pbxTimeZone={pbxTimeZone}
          toast={hotelsToast}
          permissions={permissions}
          t={t}
          locale={locale}
        />
      )}
    </HotelsAccessGate>
  )
}
